import { NextSeo } from 'next-seo';
import { useIntl } from 'react-intl';

import { Banner } from '@/core/components/Layout/Banner';
import { MarginWrapper } from '@/core/components/MarginWrapper';
import { Breadcrumbs } from '@/core/components/Breadcrumbs';
import {
  Subheader,
  Title,
  TitleWrapper,
  Wrapper,
} from '@/core/components/PageLayout';
import { navigationMessages } from '@/core/messages/navigation.messages';
import { useLocalizedOGTitle } from '@/core/hooks/useLocalizedOGTitle';

import {
  getBackendImage,
  getKeywordsProps,
} from '@/utils/helpers';

import { MediaDataType } from './media.types';
import { MediaList } from './MediaList';

type MediaPageProps = {
  mediaData: MediaDataType;
}

export const MediaPage = ({ mediaData }: MediaPageProps) => {
  const { formatMessage } = useIntl();
  const {
    linksData,
    pageData,
  } = mediaData;

  const OGTitle = useLocalizedOGTitle(
    pageData.data.attributes.meta?.OGTitle ||
    pageData.data.attributes.meta?.title ||
    formatMessage(navigationMessages.inTheNews)
  );

  return (
    <>
      <NextSeo
        title={pageData.data.attributes.meta?.title || formatMessage(navigationMessages.inTheNews)}
        description={pageData.data.attributes.meta?.description || ''}
        openGraph={{
          description: pageData.data.attributes.meta?.OGDescription ||
            pageData.data.attributes.meta?.description || '',
          title: OGTitle,
        }}
        {...getKeywordsProps(pageData.data.attributes.meta?.keywords)}
      />
      <div>
        <Banner
          TitleText={pageData.data.attributes.banner.header}
          Image={getBackendImage(
            pageData.data.attributes.banner.banner.data?.attributes?.url
          )}
          SubtitleText={pageData.data.attributes.banner.paragraph}
        />
        <Breadcrumbs />
        <Wrapper>
          <MarginWrapper>
            <TitleWrapper>
              <Subheader>{pageData.data.attributes.header.subtitle}</Subheader>
              <Title>{pageData.data.attributes.header.title}</Title>
            </TitleWrapper>
            <MediaList data={linksData} />
          </MarginWrapper>
        </Wrapper>
      </div>
    </>
  );
};

